module.exports = __webpack_public_path__ + "static/media/rank-b.0720c25c.png";